import { useContext } from "react";
import { translations } from "../../translations";
import { LanguageContext } from "../../ThemeProvider/ThemeProvider";
import { injectVars, resolveMessage } from "./helpers";
export const useTranslations = (translations) => {
    const lang = useContext(LanguageContext);
    const messages = translations[lang];
    return (path, vars) => {
        const message = resolveMessage(messages, path);
        return injectVars(message, vars);
    };
};
export const useGlobalTranslations = () => {
    return useTranslations(translations);
};
//# sourceMappingURL=useTranslations.js.map